import saveAs from "file-saver";
import config from "../config.json";
import { IPageable, Params } from "../types/table/interfaces.type";
import { createAxiosInstance } from "./ServicesHelpers";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

const axiosInstance = createAxiosInstance(config.ADMIN_API_BASE_URL);

export interface IPayment {
  id: number;
  amount: number;
  ref: string;
  createdDate: Date;
  invoiceId: string;
  profileId: string;
  connectionProfileIds: number[];
  paymentDate: Date;
  paymentType: PaymentTypeEnum;
  currencyId: number;
  type: AccountyEnumType;
  updatedBy?: string;
}
export enum AccountyEnumType {
  CLIENT_PAYMENT = "CLIENT_PAYMENT",
  VENDOR_PAYMENT = "VENDOR_PAYMENT",
}
export enum PaymentTypeEnum {
  CHEQUE = "CHEQUE",
  CASH = "CASH",
  CREDIT_CARD = "CREDIT_CARD",
  BANK_TRANSFER = "BANK_TRANSFER",
}


export const exportPayment = async (
  params: Params<IPayment> = {}
): Promise<void> => {
  try {
    const response = await axiosInstance.get("/payments/csv", {
      params,
      responseType: "blob",
    });

    const disposition = response.headers["content-disposition"];
    let filename = "Payment.csv";
    if (disposition) {
      const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (match && match[1]) {
        filename = match[1].replace(/['"]/g, "").trim();
      }
    }

    const blob = new Blob([response.data], { type: "text/csv" });
    saveAs(blob, filename);

    console.log("Export successful and file downloaded.");
  } catch (error: any) {
    console.error(
      "Error fetching Payment:",
      error.response?.data?.message || error.message || error
    );
  }
};

export async function fetchPayments(
  params: Params<IPayment>
): Promise<IPageable<IPayment>> {
  try {
    const response = await axiosInstance.get("/payments", { params });
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while getting the users."
    );
  }
}

export async function fetchPayment(id: IPayment["id"]): Promise<IPayment> {
  try {
    const response = await axiosInstance.get(`/payments/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        `An error occurred while getting routing-plan/${id}.`
    );
  }
}
export async function fetchPaymentType() {
  try {
    const response = await axiosInstance.get<string[]>("/payment-types");
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        `An error occurred while getting payment types.`
    );
  }
}

export const addPaymentApi = async (data: Partial<IPayment>) => {
  try {
    const response = await axiosInstance.post("/payments", data);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while adding the payments."
    );
  }
};

export const usePaymentQuery = (
  params: Params<IPayment>
): UseQueryResult<IPageable<IPayment>, Error> => {
    const effectiveParams = {
    ...params,
    sort: params.sort || "createdDate,desc",
  };

  const queryKey = ["payment", JSON.stringify(effectiveParams)];
  return useQuery({
    queryKey,
    queryFn: () => fetchPayments(effectiveParams),
  });
};